'use strict';

var InviteToSitePromptDialogController = function($scope, $state, Flux, InviteToSiteActions, IntercomService, SettingsService) {
  var SettingsStore = Flux.Store.get('SettingsStore');
  var vm = this;
  vm.empty = false;
  vm.created = false;

  vm.handleInvitationSuccess = function handleInvitationSuccess () {
    var payload = SettingsStore.get('raw');
    var flag = true;
    if (payload.fromUserId) {
      vm.recipient = payload.email;
      vm.added = payload.projectName;
    } else {
      vm.created = true;
      vm.recipient = payload.user.email;
      if (payload.newProjects.length > 0){
        vm.added = payload.newProjects[0].name;
      } else {
        flag = false;
      }
    }
    if (flag) {
      vm.showDialogSuccess = true;
    } else {
      vm.handleInvitationError();
    }
  };

  vm.handleInvitationError = function handleInvitationError () {
    var error = SettingsStore.get('message');
    if (error.friendlyMessage){
      if (error.friendlyMessage.startsWith('ER_DUP_ENTRY')) {
        var myRegexp = /email-(\S+)/;
        var match = myRegexp.exec(error.friendlyMessage);
        vm.targetEmail = match[1].replace(/'\s*$/, '');
      }
      if (error.message === 'ValidationError' || error.message === 'DefaultError'){
        vm.errorList.push(error.friendlyMessage);
        if (error.friendlyMessage === SettingsService.OUT_OF_SEATS_ERROR || error.friendlyMessage === SettingsService.NO_SEATS_REMAINING_ERROR) {
          vm.needsMoreSeats = true;
        }
        for(var key in error.meta.errors){
          if (error.meta.errors[key]){
            for(var msg in error.meta.errors[key]){
              if (error.meta.errors[key][msg]){
                vm.errorList.push(error.meta.errors[key][msg]);
              }
            }
          }
        }
      }
    }
    else if (error.empty){
      vm.empty = true;
      vm.targetEmail = error.user.email;
    }
    vm.showDialogRejected = true;
  };

  vm.closeModal = function () {
    _init();
    InviteToSiteActions.CancelInviteToSite.dispatch();
  };

  vm.addAnother = function () {
    vm.closeModal();
    InviteToSiteActions.InviteToSite.dispatch();
  };

  vm.contactSupport = function () {
    vm.closeModal();
    IntercomService.show();
  };

  vm.goToSettings = function goToSettings() {
    $state.go('settings.myProfile');
  };

  vm.goToSeats = function goToSeats() {
    $state.go('settings.organization.users', {command: 'seats'});
  };

  var _init = function () {
    vm.targetEmail = null;
    vm.errorList = [];
    vm.showDialogSuccess = false;
    vm.showDialogRejected = false;
    vm.needsMoreSeats = false;
  };

  _init();

  SettingsStore.on(SettingsStore.Events.InvitationSuccess, this.handleInvitationSuccess.bind(this), $scope);
  SettingsStore.on(SettingsStore.Events.InvitationError, this.handleInvitationError.bind(this), $scope);
};

InviteToSitePromptDialogController.$inject = ['$scope', '$state', 'sbFlux', 'InviteToSiteActions', 'IntercomService', 'SettingsService'];

module.exports = InviteToSitePromptDialogController;



// WEBPACK FOOTER //
// ./src/app/dash/invite/dialog/InviteToSitePromptDialogController.js